module.exports = __webpack_public_path__ + "static/media/btn_pc.e9a8e2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/EBook/imgs/btn_pc.png
// module id = 1640
// module chunks = 0